import { AxiosHttpService } from 'services/AxiosHttpService';
import { ProfileRepository } from 'repository/auth/ProfileRepository';
import { UserRepository } from 'repository/auth/UserRepository';
import { ViewRepository } from 'repository/auth/ViewRepository';
import { PermissionRepository } from 'repository/auth/PermissionRepository';
import { ReportRepository } from 'repository/auth/ReportRepository';
import { ClientRepository } from 'repository/auth/ClientRepository.ts';
import { createApiClient } from "utils/AxiosClient";
import { ICacheService } from './ICacheService';
import { CacheService } from 'services/CacheService';

export class AuthService {
    private cacheService: ICacheService;

    private httpService: IHttpService;

    public user: IUserRepository
    public profile: IProfileRepository
    public view: IViewRepository
    public permission: IPermissionRepository
    public report: ReportRepository
    public client: IClientRepository


    constructor(url?: string) {
        this.cacheService = new CacheService('tk-cache-db');
        const baseURL = url ? url : `${process.env.REACT_APP_TK_GW_DOMAIN}/v1/auth`;
        const apiClient = createApiClient(baseURL)
        this.httpService = new AxiosHttpService(apiClient, this.cacheService);

        this.user = new UserRepository(this.httpService);
        this.profile = new ProfileRepository(this.httpService);
        this.view = new ViewRepository(this.httpService);
        this.permission = new PermissionRepository(this.httpService);
        this.report = new ReportRepository(this.httpService);
        this.client = new ClientRepository(this.httpService);

    }
}



